export default "__VITE_ASSET__d119489e__"